export class Individual {
    uiClientId!:string | null;
    uiTeamId!: any;
    isBatch!: boolean;
    stSubmissionFileName!: string | null;
    stBatchName!: string;
    uiCreatedBy!: string;
    stTimeZone!: string;
    fFaceImage! : string;
    /** Optional link-out correlation id passed to generateClaims when present. */
    correlationId?: string | null;
    lstClaimRequestSubmissions!: any 
}

export class ResponseIdNamePairs {
  ResponseIdNamePairs() {
    this.statusCode = 0;
    this.status = '';
    this.data =  [];
  }
  
  statusCode!: number;
  status!: string;
  data!: ResultSet[];
}

class ResultSet {
  Id!: string;
  Name!: string;

  // Use this properties to get any additional data in common model
  data1!: string;
  id!: string;
}